import { lazy } from "react";

export const BackButton = lazy(() => import("./BackButton"));
export const Blog = lazy(() => import("./Blog"));
export const BranchCard = lazy(() => import("./BranchCard"));
export const Branches = lazy(() => import("./Branches"));
export const Button = lazy(() => import("./Button"));
export const Button2 = lazy(() => import("./Button2"));
export const CertificateCard = lazy(() => import("./CertificateCard"));
export const Certificates = lazy(() => import("./Certificates"));
export const ContentSection = lazy(() => import("./ContentSection"));
export const DescriptionSection = lazy(() => import("./DescriptionSection"));
export const FormSection = lazy(() => import("./FormSection"));
export const Hero = lazy(() => import("./Hero"));
export const HomeHero = lazy(() => import("./HomeHero"));
export const InsightCard = lazy(() => import("./InsightCard"));
export const InsightHero = lazy(() => import("./InsightHero"));
export const Insights = lazy(() => import("./Insights"));
export const JobCard = lazy(() => import("./JobCard"));
export const JobDetail = lazy(() => import("./JobDetail"));
export const Jobs = lazy(() => import("./Jobs"));
export const JobsFeed = lazy(() => import("./JobsFeed"));
export const JoinUs = lazy(() => import("./JoinUs"));
export const Logos = lazy(() => import("./Logos"));
export const Offers = lazy(() => import("./Offers"));
export const OurTeam = lazy(() => import("./OurTeam"));
export const Paginations = lazy(() => import("./InsightsFeed"));
export const Sectors = lazy(() => import("./Sectors"));
export const ServiceCard = lazy(() => import("./ServiceCard"));
export const Services = lazy(() => import("./Services"));
export const SpecialismCard = lazy(() => import("./SpecialismCard"));
export const Specialisms = lazy(() => import("./Specialisms"));
export const Stats = lazy(() => import("./Stats"));
export const TeamCard = lazy(() => import("./TeamCard"));
export const SeoHead = lazy(() => import("./SeoHead"));
